/** @jsx jsx */
import { jsx } from '@emotion/core';
import { SolutionCardsKeys } from '../../../../utils/dictionarykeys';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import { fieldHasValue } from '../../../../utils/sitecore';
import CtaLink from '../../../ui/CtaLink';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import isEmpty from 'lodash/isEmpty';
import * as styles from './index.styles';

const defaultData = {
  fields: {
    IsMiscCardFixed: {
      value: false,
    },
    Headline: {
      value: '',
    },
    Description: {
      value: '',
    },
  },
};

const getCTAsProps = CTAs => {
  return CTAs.map(cta => {
    const id = get(cta, 'id', '');
    const href = get(cta, 'fields.PagePath.value', '');
    const text =
      get(cta, 'fields.Solution.fields.SolutionName.value') ||
      get(cta, 'fields.Solution.fields.ProtonName.value', '');

    return {
      value: {
        anchor: null,
        href,
        id,
        linktype: 'internal',
        querystring: null,
        target: null,
        text,
      },
    };
  });
};

const templateCtas = CTAs => {
  return CTAs.map(cta => (
    <div key={cta.value.id}>
      <CtaLink cta={cta} linkCustomCss={styles.ctaLinkCss} />
    </div>
  ));
};

class MiscCard extends SafePureComponent {
  componentDidMount() {
    console.log(this.props);
  }
  safeRender() {
    const { props } = this;
    const data = defaultsDeep(props.fields, defaultData);
    const { fields } = data;
    const { CTAs } = fields;
    const { t } = this.props;
    const CTAsObject = getCTAsProps(CTAs);


    return (
      <div css={styles.cardCss} data-item={'misc-card'}>
        <h3 css={styles.headlineCss}>
          {fields.IsMiscCardFixed.value ? (
            t(SolutionCardsKeys.MiscCardsForGeoSolutionTitle)
          ) : (
            <Text field={fields.Headline} />
          )}
        </h3>
        {fieldHasValue(fields.Description) && (
          <p css={styles.descriptionCss}>
            <Text field={fields.Description} />
          </p>
        )}
        {!isEmpty(CTAs) && templateCtas(CTAsObject)}
      </div>
    );
  }
}

MiscCard.defaultProps = { fields: defaultData };

MiscCard.propTypes = {
  fields: PropTypes.shape({
    IsMiscCardFixed: PropTypes.shape({
      value: PropTypes.bool,
    }),
    Headline: PropTypes.shape({
      value: PropTypes.string,
    }),
    Description: PropTypes.shape({
      value: PropTypes.string,
    }),
    CTAs: PropTypes.shape([
      {
        id: PropTypes.string,
        fields: PropTypes.shape({
          PagePath: PropTypes.shape({
            value: PropTypes.string,
          }),
          Solution: PropTypes.shape({
            fields: PropTypes.shape({
              ProtonName: PropTypes.shape({
                value: PropTypes.string,
              }),
            }),
          }),
        }),
      },
    ]),
  }),
};

MiscCard.displayName = 'SolutionsCards/MiscCard';

export default compose(withSitecoreContext(), withNamespaces())(MiscCard);
